'use client';

import { useLayoutEffect } from 'react';

import {
  clearMarketingBodyLeftovers,
  clearCompanyBodyLeftovers,
  enableRouteStylesheets,
  removeRouteStylesheets,
} from '@/lib/styles/route-stylesheets';

const MARKETING_BODY_CLASS = 'kw-marketing-body';

/**
 * Applies marketing body isolation before paint.
 * Soft-nav leaves foreign layout <link>s in <head>; disable those and re-enable
 * marketing sheets so Materialize/login CSS cannot reshape the hero.
 */
export function MarketingBodyReset() {
  useLayoutEffect(() => {
    const body = document.body;
    clearCompanyBodyLeftovers(body);
    body.classList.add(MARKETING_BODY_CLASS);

    // Scrub foreign first, then re-enable marketing — otherwise company/login
    // scrub can re-disable shared Google Font / Material Icon sheets.
    removeRouteStylesheets(['login', 'ai-bio', 'company']);
    enableRouteStylesheets('marketing');

    // Soft-nav from login/account can leave Materialize `html { font-size: 10px }`
    // in a bundled CSS chunk (not a <link>, so scrub cannot clear it). Rem-based
    // marketing landings need a normal root.
    const root = document.documentElement;
    const previousRootFontSize = root.style.fontSize;
    root.style.fontSize = '16px';

    return () => {
      root.style.fontSize = previousRootFontSize;
      clearMarketingBodyLeftovers(body);
    };
  }, []);

  return null;
}
